export default __webpack_public_path__ + "static/media/horse-realistic-1.e65bd41c.svg";